/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import Code from 'components/Code';
import Table, {Row, Column} from 'components/Table';
function _createMdxContent(props) {
  const _components = Object.assign({
    h3: "h3",
    code: "code",
    blockquote: "blockquote",
    p: "p",
    a: "a",
    ol: "ol",
    li: "li"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.h3, {
      children: [_jsx(_components.code, {
        children: ".withComponent"
      }), "(", _jsx(_components.code, {
        children: ".withComponent"
      }), ")"]
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsxs(_components.p, {
        children: [_jsx(_components.code, {
          children: "withComponent"
        }), " API 在 styled-components v4 中被 ", _jsxs(_components.a, {
          href: "#as-polymorphic-prop",
          children: [_jsx(_components.code, {
            children: "\"as\""
          }), " 属性"]
        }), " 取代，并在 v6 中完全删除。"]
      }), "\n", _jsxs(_components.p, {
        children: ["¥The ", _jsx(_components.code, {
          children: "withComponent"
        }), " API was replaced by ", _jsxs(_components.a, {
          href: "#as-polymorphic-prop",
          children: [_jsx(_components.code, {
            children: "\"as\""
          }), " prop"]
        }), " in styled-components v4, and fully-removed in v6."]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["这是一种创建新的 ", _jsx(_components.code, {
        children: "StyledComponent"
      }), " 的方法，其中应用了不同的标签或组件，但其规则与调用它的规则相同。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥This is a method that creates a new ", _jsx(_components.code, {
        children: "StyledComponent"
      }), " with a different tag or component\napplied to it, but all the same rules of the one it's called on."]
    }), "\n", _jsx(Table, {
      head: ['Arguments', 'Description'],
      children: _jsxs(Row, {
        children: [_jsx(Column, {
          children: _jsxs(_components.ol, {
            children: ["\n", _jsxs(_components.li, {
              children: [_jsx(Code, {
                children: "component"
              }), " / ", _jsx(Code, {
                children: "tagname"
              })]
            }), "\n"]
          })
        }), _jsx(Column, {
          children: _jsxs(_components.p, {
            children: ["Either a valid react component or a tagname like ", _jsx(_components.code, {
              children: "'div'"
            }), "."]
          })
        })]
      })
    }), "\n", _jsxs(_components.p, {
      children: ["返回一个新的 ", _jsx(_components.code, {
        children: "StyledComponent"
      }), "，并在使用时应用新的标签/组件。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Returns a new ", _jsx(_components.code, {
        children: "StyledComponent"
      }), " with the new tag / component being applied when it's used."]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
